import { render, staticRenderFns } from "./addmarketStatus.vue?vue&type=template&id=0cebdd40&"
import script from "./addmarketStatus.vue?vue&type=script&lang=js&"
export * from "./addmarketStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cebdd40')) {
      api.createRecord('0cebdd40', component.options)
    } else {
      api.reload('0cebdd40', component.options)
    }
    module.hot.accept("./addmarketStatus.vue?vue&type=template&id=0cebdd40&", function () {
      api.rerender('0cebdd40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/marketStatus/components/addmarketStatus.vue"
export default component.exports